import { Injectable } from '@angular/core';
import { find } from 'lodash';

interface Country {
  phone_prefix: string;
  phone_mask: string[];
  code: string;
  name: string;
  phone: {
    mask: string;
    placeholder: string;
    prefix: string;
  };
  states: State[];
}

interface State {
  code: string;
  name: string;
}

@Injectable()
export class CountriesService {
  countries: Country[];

  setCountries(countries = [], geo_info) {
    this.countries = countries.map((country) => {
      // country.phone_mask = country.phone.mask.split('').map((item) => {
      //   return item === '0' ? /\d/ : item;
      // });
      country.phone_prefix = geo_info.phone_prefix;
      return country;
    });
  }

  get(code) {
    return find(this.countries, country => country.code === code);
  }
}
